<template>
  <div class="customLayoutContent">
    <template v-if="data.config.type == 'layoutLine'">
      <div class="layoutLine defalut" v-if="!data.config.component.components.length">
        <img src="@/assets/images/normal.png" />
      </div>
      <template v-else>
        <div class="layoutLine"  v-for="(v,k) in data.config.component.components" :key="k">
          <component :is="v" :data="data.config.component.items[k]" :gobleStyle="gobleStyle"/>
        </div>
      </template>
    </template>
    <template v-if="data.config.type == 'layoutColumns'">  
        <div class="customLayoutColumnsContent" >
           <div class="layoutColumns" v-for="(v,k) in data.config.component.components" :key="k">
                  <component :is="v" :data="data.config.component.items[k]" :gobleStyle="gobleStyle" />
            </div>
          <template v-if="data.config.component.components.length<2">
              <div class="layoutColumns defalut" v-for="(v,k) in  2-Number(data.config.component.components.length)" :key="k">
                <img src="@/assets/images/normal.png" />
              </div>
          </template>
        </div>
    </template>
    <template v-if="data.config.type == 'layoutThree'">
      <div class="customLayoutThreeContent">
          <div class="layoutColumns defalut" v-for="(v,k) in data.config.component.components" :key="k">
                  <component :is="v" :data="data.config.component.items[k]" :gobleStyle="gobleStyle" />
            </div>
          <template v-if="data.config.component.components.length<3">
              <div class="layoutColumns" v-for="(v,k) in  3-Number(data.config.component.components.length)" :key="k">
                <img src="@/assets/images/normal.png" />
              </div>
          </template>
      </div>
    </template>
    <template v-if="data.config.type == 'layoutFour'">
      <div class="customLayoutFourContent">
         <div class="layoutColumns defalut" v-for="(v,k) in data.config.component.components" :key="k">
                  <component :is="v" :data="data.config.component.items[k]" :gobleStyle="gobleStyle"/>
            </div>
          <template v-if="data.config.component.components.length<4">
              <div class="layoutColumns " v-for="(v,k) in  4-Number(data.config.component.components.length)" :key="k">
                <img src="@/assets/images/normal.png" />
              </div>
          </template>
      </div>
    </template> 
    <template v-if="data.config.type == 'layoutTabs'">
      <div class="customLayoutTabsContent">
        <div class="layoutTabs">
          <div class="layoutTabsHeader">
            <div class="active themeActive" v-if="!data.config.component.components.length">默认 
                <div class="line"  :style="'background-color:'+gobleStyle.themeColor"></div>
            </div>
            <div :class="active==k?'active':''" @click="active=k" v-for="(v,k) in data.config.component.items" :key="k" >{{v.name}}
                <div class="line"  :style="'background-color:'+gobleStyle.themeColor"></div>
            </div>
          </div>
          <div class="layoutMain defalut" v-if="!data.config.component.components.length">
            <img src="@/assets/images/normal.png" />
          </div>
            <template v-else>
              <div class="layoutMain" v-for="(v,k) in data.config.component.components" :key="k" v-show="active==k">
                <component :is="v" :data="data.config.component.items[k]" :gobleStyle="gobleStyle" />
              </div>
            </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import banner from "../components/banner/index";
import blank from "../components/blank/index";
import windows from "../components/windows/index";
import nav from "../components/nav/index";
import goods from "../components/goods/index";
import trace from "../components/trace/index";
import enterprise from "../components/enterprise/index";
import bottomNav from "../components/bottomNav/index";
import { ref } from '@vue/reactivity';
import { inject } from '@vue/runtime-core';

export default {
  components:{banner,blank,windows,nav,goods,trace,enterprise,bottomNav},
  props: {
    data: Object,
    gobleStyle:Object
  },
  setup() {
    const active=ref(0)
    return{
      active
     }

  },
};
</script>
<style lang="less" scoped>
.customLayoutContent {
  padding:7px;
  .layoutLine {
    width: 100%;
    border: 1px dashed #eee;
    img {
      width: 100%;
    }
  }
  .customLayoutColumnsContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .layoutColumns {
      width: 48%;
      margin-right: 1%;
      // margin-bottom: 14px;
      img {
        width: 100%;
      }
    }
  }
  .customLayoutThreeContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .layoutColumns {
      width: 32%;
      margin-right: 1%;
      img {
        width: 100%;
      }
    }
  }
  .customLayoutFourContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .layoutColumns {
      width: 24%;
      margin-right: 1%;
      img {
        width: 100%;
      }
    }
  }
  .customLayoutTabsContent {
    .layoutTabs {
      // background-color: #fff;
      border-radius: 6px;
      .layoutTabsHeader {
        width: 100%;
        height: 50px;
        display: flex;
        text-align: center;
        padding-top: 15px;
        > div {
          flex: 1;
          position: relative;
        }
        .active {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #131313;
         .line {
            content: "";
            width: 20px;
            height: 4px;
            background: #4fa1fc;
            border-radius: 2px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      .layoutMain {
        padding: 15px 12px;
        img {
          width: 100%;
        }
      }
    }
  }
  .defalut {
    position: relative;
    &::before{
      content:"";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.3);
      display: flex;
      align-content: center;
      justify-content: center;
    }
    &::after{
      content:"可拖动基础组件放置此处";
      position: absolute;
      color: #fff;
      font-size: 12px;
      top: 50%;
      width: 100%;
      transform: translate(-50%,-50%);
      z-index: 1;
      text-align: center;
      left: 50%;
    }
  }
}
</style>
